import axios from 'axios';
import { getAccessToken } from '../requestService';

export const initBasicAuth = async (memberId: string): Promise<void> => {
  const token = await getAccessToken({ memberId, tokenType: 'ACCESS_TOKEN' });
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};
